import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useSnackbar } from 'notistack';
import { CrossIcon } from '../icons';
const Notification = () => {
  const {
    enqueueSnackbar,
    closeSnackbar
  } = useSnackbar();
  const notification = useSelector(state => state.notification);
  const action = key => /*#__PURE__*/React.createElement("span", {
    style: {
      padding: '10px',
      cursor: 'pointer'
    },
    onClick: () => closeSnackbar(key)
  }, /*#__PURE__*/React.createElement(CrossIcon, {
    size: "small"
  }));
  useEffect(() => {
    if (notification.message && enqueueSnackbar) {
      enqueueSnackbar(notification.message, {
        action,
        variant: notification.variant,
        autoHideDuration: 3000,
        anchorOrigin: {
          vertical: 'bottom',
          horizontal: 'right'
        }
      });
    }
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null);
};
export default Notification;